<template>
    <div
        ref="renderer"
    >
        <camera-view
            v-if="previewMode === '3d'"
            :controller="viewController"
            :view="currentView"
            @camera-loading="cameraLoading"
        />

        <div v-if="previewMode === '2d'" class="cz__flat-preview">
            <div ref="swiper" class="swiper">
                <div class="swiper-wrapper">
                    <product-view v-for="view in flatViews" :key="view.code" :view="view">
                    </product-view>
                </div>

                <!-- eslint-disable -->

                <div ref="prev" class="swiper-button-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M18.7 256l22.6 22.6 160 160L224 461.3 269.3 416l-22.6-22.6L109.3 256 246.6 118.6 269.3 96 224 50.7 201.4 73.4l-160 160L18.7 256z"/></svg>
                </div>
                <div ref="next" class="swiper-button-next">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M301.3 256l-22.6 22.6-160 160L96 461.3 50.7 416l22.6-22.6L210.7 256 73.4 118.6 50.7 96 96 50.7l22.6 22.6 160 160L301.3 256z"/></svg>
                </div>
            </div>
        </div>

        <div class="cz__options-panel">
            <button class="cz__option-button" :class="{
                'cz__option-button--selected': previewMode === '2d'
            }"
                @click.prevent="selectMode('2d')"
            >2D</button>

            <button class="cz__option-button" :class="{
                'cz__option-button--selected': previewMode === '3d'
            }"
                @click.prevent="selectMode('3d')"
            >3D</button>
        </div>
    </div>
</template>

<style lang="scss">
    #cz3 {
        .cz__options-panel {
            position: absolute;

            left: 20px;
            top: 20px;

            display: flex;
            gap: 15px;

            z-index: 1000;
        }

        .cz__flat-preview {
            position: absolute;

            inset: 0;

            .swiper {
                position: absolute;

                inset: 0;
            }

            .swiper-slide {
                position: relative;

                width: 100%;
                height: 100%;
            }
        }

        .cz__flat-preview {
            .swiper-button-prev, .swiper-button-next {
                position: absolute;

                width: 50px;
                height: 50px;

                top: calc(50% - 25px);

                svg {
                    position: absolute;

                    width: 50px;
                    height: 50px;

                    left: 0;
                    top: 0;
                }

                &:after {
                    display: none;
                }
            }

            .swiper-button-prev {
                left: 20px;
            }

            .swiper-button-next {
                right: 20px;
            }
        }
    }
</style>

<script>
    // eslint-disable-next-line import/no-unresolved
    import Swiper from 'swiper/bundle';

    import CameraView from './Three/CameraView.vue';
    import ProductView from './ProductView.vue';

    import allStores from '../stores/all';

    import emitter from '../helpers/bus';

    export default {
        mixins: [allStores],

        components: {
            CameraView,
            ProductView,
        },

        computed: {
            currentStep() {
                return this.appStore.currentStep;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            currentView() {
                return this.customizerStore.currentView;
            },

            previewMode() {
                return this.customizerStore.previewMode;
            },

            flatViews() {
                if (this.viewController == null) {
                    return [];
                }

                return this.viewController.blueprint.views.filter((x) => x.custom?.['baa-view'] === 'flat');
            },
        },

        watch: {
            currentStep() {
                this.$nextTick(() => {
                    this.resize();
                });
            },
        },

        mounted() {
            this.resize();

            this.build2d();
        },

        updated() {
            if (this.previewMode === '2d') {
                this.build2d();
            }
        },

        methods: {
            resize() {
                const parent = this.$el.closest('.cz3');

                if (parent) {
                    const excludes = Array.from(parent.querySelectorAll('.cz3-renderer-exclude'));

                    let excludeHeight = 0;

                    // Margins.
                    const isLarge = window.innerWidth > 1024;

                    if (isLarge) {
                        excludeHeight += 24 + 24;
                    } else {
                        excludeHeight += 16;
                    }

                    excludes.forEach((el) => {
                        excludeHeight += el.offsetHeight;
                    });

                    this.$refs.renderer.style.setProperty('--exclude-height', `${excludeHeight}px`);
                }
            },

            cameraLoading(status) {
                // Hide loading indicator when camera view is done.
                // We are not going to arm the loading screen here since we use smooth fading for minor updates.
                // The status will be armed at:
                // * At load
                // * When reloading a blueprint.
                if (status === false) {
                    this.appStore.setIsLoading(status);

                    emitter.$emit('clearPoster', {
                        duration: 350,
                        allowRelease: true,
                    });
                }
            },

            selectMode(mode) {
                if (this.previewMode !== mode) {
                    if (this.swiper) {
                        this.swiper.destroy();
                    }

                    this.customizerStore.setPreviewMode(mode);

                    if (mode === '2d') {
                        this.$nextTick(() => {
                            this.build2d();
                        });
                    }
                }
            },

            build2d() {
                if (this.swiper) {
                    this.swiper.destroy();
                    this.swiper = null;
                }

                this.swiper = new Swiper(this.$refs.swiper, {
                    loop: false,

                    slidesPerView: 1,

                    preventClicks: true,

                    navigation: {
                        nextEl: this.$refs.next,
                        prevEl: this.$refs.prev,
                    },
                });
            },
        },
    };
</script>
